import script from "./roleManage.vue?vue&type=script&setup=true&lang=js"
export * from "./roleManage.vue?vue&type=script&setup=true&lang=js"

import "./roleManage.vue?vue&type=style&index=0&id=5b6c544a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6c544a"]])

export default __exports__